import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "./analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // This runs every time the 'location' object changes
    logPageView();
  }, [location]);

  return null;
};

export default AnalyticsTracker;
